import type { DialogNode } from '../types';

export const DIALOG: DialogNode[] = [
  {
    "id": 1,
    "pere": null,
    "cle": "welcome",
    "message": "Bonjour et bienvenue, je m'appelle Sarah et je suis à votre disposition pour toute information sur le test psychotechnique.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 2,
    "pere": "welcome",
    "cle": "accept",
    "message": {
      "img": "",
      "texte": "Oui, avec plaisir !"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 3,
    "pere": "welcome",
    "cle": "ignore",
    "message": {
      "img": "",
      "texte": "Je veux directement trouver une date de test dans mon département."
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 4,
    "pere": "accept",
    "cle": "raisons",
    "message": "<p>Bonjour, je suis Sarah, votre assistante pour le test psychotechnique.</p><p>Pour vous orienter au mieux, dites-moi <b>pourquoi vous devez en passer un</b>.</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 5,
    "pere": "raisons",
    "cle": "retrait-permis",
    "message": {
      "img": "retrait-de-permis.png",
      "texte": "Retrait de permis"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 6,
    "pere": "raisons",
    "cle": "professionnel",
    "message": {
      "img": "professionnel.png",
      "texte": "Professionnel"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 7,
    "pere": "retrait-permis",
    "cle": "retrait-type",
    "message": "<p>D'accord. <b>Quel type de retrait vous concerne ?</b></p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 8,
    "pere": "retrait-type",
    "cle": "suspension",
    "message": {
      "img": "",
      "texte": "Suspension du permis"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 9,
    "pere": "retrait-type",
    "cle": "annulation",
    "message": {
      "img": "",
      "texte": "Annulation du permis"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 10,
    "pere": "retrait-type",
    "cle": "invalidation",
    "message": {
      "img": "",
      "texte": "Invalidation du permis"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 11,
    "pere": "retrait-type",
    "cle": "retrait-inconnu",
    "message": {
      "img": "",
      "texte": "Je ne sais pas exactement, aidez-moi à identifier ma situation."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 12,
    "pere": "suspension",
    "cle": "ask-suspension",
    "message": "Combien de temps dure votre suspension de permis ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 13,
    "pere": "ask-suspension",
    "cle": "suspension-inferieure",
    "message": {
      "img": "",
      "texte": "Inférieure à 6 mois"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 14,
    "pere": "ask-suspension",
    "cle": "suspension-superieure",
    "message": {
      "img": "",
      "texte": "6 mois ou plus"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 15,
    "pere": "suspension-inferieure",
    "cle": "ask-prefecture-medecin",
    "message": "<p>Avez-vous reçu, de la commission médicale de la préfecture ou d'un médecin agréé, une demande de test psychotechnique en examen complémentaire ?</p><p>Voici un exemple de courrier type. Cette demande peut aussi être formulée à l'oral par le médecin ou son cabinet.</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 16,
    "pere": "ask-prefecture-medecin",
    "cle": "pm-oui",
    "message": {
      "img": "",
      "texte": "Oui"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 17,
    "pere": "ask-prefecture-medecin",
    "cle": "pm-non",
    "message": {
      "img": "",
      "texte": "Non"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 18,
    "pere": "pm-non",
    "cle": "i-no-pm",
    "message": "<p>D'après votre situation, vous n'avez <b>pas besoin</b> de passer de test psychotechnique.</p><p>En cas de doute, n'hésitez pas à vérifier auprès de votre préfecture ou de votre médecin agréé.</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 19,
    "pere": "pm-oui",
    "cle": "ask-infraction-6",
    "message": "Avez-vous eu un retrait de permis pour alcoolémie ou stupéfiants ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 20,
    "pere": "ask-infraction-6",
    "cle": "mr-alcoolemie",
    "message": {
      "img": "alcoolemie.png",
      "texte": "Alcoolémie"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 21,
    "pere": "ask-infraction-6",
    "cle": "mr-stupefiant",
    "message": {
      "img": "stupefiants.png",
      "texte": "Stupéfiants"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 22,
    "pere": "ask-infraction-6",
    "cle": "mr-double",
    "message": {
      "img": "alcoolemie-stupefiant.png",
      "texte": "Alcoolémie et stupéfiants"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 23,
    "pere": "ask-infraction-6",
    "cle": "mr-autres",
    "message": {
      "img": "vitesse.png",
      "texte": "Perte de point, excès de vitesse ou autre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 24,
    "pere": "mr-alcoolemie",
    "cle": "ask-departement",
    "message": "Quel est votre département ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 25,
    "pere": "mr-stupefiant",
    "cle": "ask-departement",
    "message": "Quel est votre département ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 26,
    "pere": "mr-double",
    "cle": "ask-departement",
    "message": "Quel est votre département ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 27,
    "pere": "mr-autres",
    "cle": "ask-departement",
    "message": "Quel est votre département ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 28,
    "pere": "ask-departement",
    "cle": "form-departement",
    "message": [
      {
        "key": "formDept",
        "type": "select",
        "label": "Votre département",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Le département est requis."
          }
        ]
      }
    ],
    "type": "form",
    "ordre": 0
  },
  {
    "id": 29,
    "pere": "form-departement",
    "cle": "ask-visite",
    "message": "Très bien. Avez-vous déjà un rendez-vous pour votre visite médicale ? Si oui, indiquez la date ci-dessous.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 30,
    "pere": "ask-visite",
    "cle": "form-visite",
    "message": [
      {
        "key": "formOui",
        "type": "date",
        "label": "Oui, le",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "La date est requise."
          }
        ]
      }
    ],
    "type": "form",
    "ordre": 1
  },
  {
    "id": 31,
    "pere": "ask-visite",
    "cle": "visite-null",
    "message": {
      "img": "",
      "texte": "Pas encore, je suis dans l'attente d'une date ou je m'en occuperai plus tard."
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 32,
    "pere": "form-visite",
    "cle": "ask-informations",
    "message": "Pour recevoir vos <strong>démarches personnalisées</strong> (centre d'examen, médecins agréés, laboratoire d'analyse) et votre <strong>CERFA 14880*02 pré-rempli</strong>, complétez le formulaire ci-dessous.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 33,
    "pere": "visite-null",
    "cle": "ask-informations",
    "message": "Pour recevoir vos <strong>démarches personnalisées</strong> (centre d'examen, médecins agréés, laboratoire d'analyse) et votre <strong>CERFA 14880*02 pré-rempli</strong>, complétez le formulaire ci-dessous.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 34,
    "pere": "ask-informations",
    "cle": "form-informations",
    "message": [
      {
        "key": "formNom",
        "type": "text",
        "label": "Votre nom",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Votre nom est requis."
          }
        ]
      },
      {
        "key": "formPrenom",
        "type": "text",
        "label": "Votre prénom",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Votre prénom est requis."
          }
        ]
      },
      {
        "key": "formEmail",
        "type": "email",
        "label": "Votre email",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Votre email est requis."
          },
          {
            "name": "email",
            "validator": "email",
            "message": "Veuillez renseigner un email valide."
          }
        ]
      }
    ],
    "type": "form",
    "ordre": 0
  },
  {
    "id": 35,
    "pere": "form-informations",
    "cle": "final",
    "message": "<p>Merci ! Vous allez recevoir par email un récapitulatif complet de votre test psychotechnique et de votre visite médicale.</p><p>À bientôt !</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 36,
    "pere": "suspension-superieure",
    "cle": "ask-infraction-6",
    "message": "Avez-vous eu un retrait de permis pour alcoolémie ou stupéfiants ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 37,
    "pere": "annulation",
    "cle": "ask-lettre-4",
    "message": "Avez-vous reçu une des lettres suivantes ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 38,
    "pere": "ask-lettre-4",
    "cle": "lettre-44f",
    "message": {
      "img": "",
      "texte": "Lettre 44F"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 39,
    "pere": "ask-lettre-4",
    "cle": "lettre-7",
    "message": {
      "img": "",
      "texte": "Lettre 7"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 40,
    "pere": "ask-lettre-4",
    "cle": "annulation-lettre-none",
    "message": {
      "img": "",
      "texte": "Je n'ai pas reçu de lettre"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 41,
    "pere": "annulation-lettre-none",
    "cle": "a-lettre-none",
    "message": "<p>D'accord. Si vous avez besoin d'un duplicata, rapprochez-vous de votre préfecture.</p><p>Si vous êtes sûr de votre type de retrait, souhaitez-vous connaître les démarches de récupération du permis ?</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 42,
    "pere": "a-lettre-none",
    "cle": "a-lettre-continue",
    "message": {
      "img": "",
      "texte": "Oui"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 43,
    "pere": "a-lettre-none",
    "cle": "a-lettre-quit",
    "message": {
      "img": "",
      "texte": "Non"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 44,
    "pere": "a-lettre-continue",
    "cle": "ask-infraction-6",
    "message": "Avez-vous eu un retrait de permis pour alcoolémie ou stupéfiants ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 45,
    "pere": "lettre-44f",
    "cle": "ask-infraction-3",
    "message": "Vous êtes alors en <b>annulation administrative</b>. Maintenant que nous en savons plus sur votre situation, quelle est la raison de votre retrait ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 46,
    "pere": "lettre-7",
    "cle": "ask-infraction-4",
    "message": "Vous êtes donc en <b>annulation judiciaire</b>. Maintenant que nous en savons plus sur votre situation, quelle est la raison de votre retrait ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 47,
    "pere": "ask-infraction-3",
    "cle": "mr-alcoolemie",
    "message": {
      "img": "alcoolemie.png",
      "texte": "Alcoolémie"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 48,
    "pere": "ask-infraction-3",
    "cle": "mr-stupefiant",
    "message": {
      "img": "stupefiants.png",
      "texte": "Stupéfiants"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 49,
    "pere": "ask-infraction-3",
    "cle": "mr-double",
    "message": {
      "img": "alcoolemie-stupefiant.png",
      "texte": "Alcoolémie et stupéfiants"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 50,
    "pere": "ask-infraction-3",
    "cle": "mr-autres",
    "message": {
      "img": "vitesse.png",
      "texte": "Perte de point, excès de vitesse ou autre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 51,
    "pere": "ask-infraction-4",
    "cle": "mr-alcoolemie",
    "message": {
      "img": "alcoolemie.png",
      "texte": "Alcoolémie"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 52,
    "pere": "ask-infraction-4",
    "cle": "mr-stupefiant",
    "message": {
      "img": "stupefiants.png",
      "texte": "Stupéfiants"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 53,
    "pere": "ask-infraction-4",
    "cle": "mr-double",
    "message": {
      "img": "alcoolemie-stupefiant.png",
      "texte": "Alcoolémie et stupéfiants"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 54,
    "pere": "ask-infraction-4",
    "cle": "mr-autres",
    "message": {
      "img": "vitesse.png",
      "texte": "Perte de point, excès de vitesse ou autre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 55,
    "pere": "invalidation",
    "cle": "ask-lettre-3",
    "message": "Avez-vous reçu une des lettres suivantes ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 56,
    "pere": "ask-lettre-3",
    "cle": "lettre-48si",
    "message": {
      "img": "",
      "texte": "Lettre 48SI"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 57,
    "pere": "ask-lettre-3",
    "cle": "invalidation-lettre-none",
    "message": {
      "img": "",
      "texte": "Je n'ai pas reçu de lettre"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 58,
    "pere": "invalidation-lettre-none",
    "cle": "i-lettre-none",
    "message": "<p>D'accord. Si vous avez besoin d'un duplicata, rapprochez-vous de votre préfecture.</p><p>Si vous êtes sûr de votre type de retrait, souhaitez-vous connaître les démarches de récupération du permis ?</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 59,
    "pere": "i-lettre-none",
    "cle": "i-lettre-continue",
    "message": {
      "img": "",
      "texte": "Oui"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 60,
    "pere": "i-lettre-none",
    "cle": "i-lettre-quit",
    "message": {
      "img": "",
      "texte": "Non"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 61,
    "pere": "i-lettre-continue",
    "cle": "ask-infraction-6",
    "message": "Avez-vous eu un retrait de permis pour alcoolémie ou stupéfiants ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 62,
    "pere": "lettre-48si",
    "cle": "ask-infraction-2",
    "message": "Vous êtes alors en <b>invalidation</b>. Maintenant que nous en savons plus sur votre situation, quelle est la raison de votre retrait ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 63,
    "pere": "ask-infraction-2",
    "cle": "mr-alcoolemie",
    "message": {
      "img": "alcoolemie.png",
      "texte": "Alcoolémie"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 64,
    "pere": "ask-infraction-2",
    "cle": "mr-stupefiant",
    "message": {
      "img": "stupefiants.png",
      "texte": "Stupéfiants"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 65,
    "pere": "ask-infraction-2",
    "cle": "mr-double",
    "message": {
      "img": "alcoolemie-stupefiant.png",
      "texte": "Alcoolémie et stupéfiants"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 66,
    "pere": "ask-infraction-2",
    "cle": "mr-autres",
    "message": {
      "img": "vitesse.png",
      "texte": "Perte de point, excès de vitesse ou autre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 67,
    "pere": "retrait-inconnu",
    "cle": "ask-code-conduite",
    "message": "Pour identifier votre situation, sélectionnez l'option qui vous correspond.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 68,
    "pere": "ask-code-conduite",
    "cle": "cc-code",
    "message": {
      "img": "code.png",
      "texte": "J'ai le code à passer"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 69,
    "pere": "ask-code-conduite",
    "cle": "cc-double",
    "message": {
      "img": "conduite.png",
      "texte": "J'ai le code et la conduite à passer"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 70,
    "pere": "ask-code-conduite",
    "cle": "cc-null",
    "message": {
      "img": "aucune.png",
      "texte": "Aucun des deux"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 71,
    "pere": "ask-code-conduite",
    "cle": "cc-unknown",
    "message": {
      "img": "aide.png",
      "texte": "Je ne sais pas exactement, aidez-moi à identifier ma situation."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 72,
    "pere": "cc-code",
    "cle": "ask-lettre",
    "message": "<p>Deux situations sont possibles : <b>invalidation</b> ou <b>annulation administrative</b>. Pour préciser laquelle, quelle lettre avez-vous reçue ?</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 73,
    "pere": "ask-lettre",
    "cle": "lettre-7-bis",
    "message": {
      "img": "",
      "texte": "Lettre 7"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 74,
    "pere": "ask-lettre",
    "cle": "lettre-44f",
    "message": {
      "img": "",
      "texte": "Lettre 44F"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 75,
    "pere": "ask-lettre",
    "cle": "lettre-48si",
    "message": {
      "img": "",
      "texte": "Lettre 48SI"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 76,
    "pere": "ask-lettre",
    "cle": "lettre-autres",
    "message": {
      "img": "",
      "texte": "Je ne sais pas ou je n'ai pas reçu de lettre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 77,
    "pere": "lettre-7-bis",
    "cle": "ask-infraction-1",
    "message": "<p>Vous êtes donc en <b>annulation judiciaire</b>. Vous devrez alors <b>repasser le code et la conduite</b>.</p><p>Maintenant que nous en savons plus sur votre situation, quelle est la raison de votre retrait ?</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 78,
    "pere": "ask-infraction-1",
    "cle": "mr-alcoolemie",
    "message": {
      "img": "alcoolemie.png",
      "texte": "Alcoolémie"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 79,
    "pere": "ask-infraction-1",
    "cle": "mr-stupefiant",
    "message": {
      "img": "stupefiants.png",
      "texte": "Stupéfiants"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 80,
    "pere": "ask-infraction-1",
    "cle": "mr-double",
    "message": {
      "img": "alcoolemie-stupefiant.png",
      "texte": "Alcoolémie et stupéfiants"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 81,
    "pere": "ask-infraction-1",
    "cle": "mr-autres",
    "message": {
      "img": "vitesse.png",
      "texte": "Perte de point, excès de vitesse ou autre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 82,
    "pere": "cc-double",
    "cle": "ask-infraction-4",
    "message": "Vous êtes donc en <b>annulation judiciaire</b>. Maintenant que nous en savons plus sur votre situation, quelle est la raison de votre retrait ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 83,
    "pere": "cc-null",
    "cle": "ask-infraction",
    "message": "Vous avez donc une <b>suspension de permis</b>. Quelle en est la raison ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 84,
    "pere": "ask-infraction",
    "cle": "mr-alcoolemie",
    "message": {
      "img": "alcoolemie.png",
      "texte": "Alcoolémie"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 85,
    "pere": "ask-infraction",
    "cle": "mr-stupefiant",
    "message": {
      "img": "stupefiants.png",
      "texte": "Stupéfiants"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 86,
    "pere": "ask-infraction",
    "cle": "mr-double",
    "message": {
      "img": "alcoolemie-stupefiant.png",
      "texte": "Alcoolémie et stupéfiants"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 87,
    "pere": "ask-infraction",
    "cle": "mr-autres",
    "message": {
      "img": "vitesse.png",
      "texte": "Perte de point, excès de vitesse ou autre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 88,
    "pere": "cc-unknown",
    "cle": "ask-lettre-2",
    "message": "Quelle lettre avez-vous reçue ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 89,
    "pere": "ask-lettre-2",
    "cle": "lettre-7",
    "message": {
      "img": "",
      "texte": "Lettre 7"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 90,
    "pere": "ask-lettre-2",
    "cle": "lettre-44f",
    "message": {
      "img": "",
      "texte": "Lettre 44F"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 91,
    "pere": "ask-lettre-2",
    "cle": "lettre-48si",
    "message": {
      "img": "",
      "texte": "Lettre 48SI"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 92,
    "pere": "ask-lettre-2",
    "cle": "lettre-autres",
    "message": {
      "img": "",
      "texte": "Je ne sais pas ou je n'ai pas reçu de lettre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 93,
    "pere": "lettre-autres",
    "cle": "ask-infraction-5",
    "message": "Vous avez soit une <b>invalidation de permis</b>, soit une <b>annulation de permis</b>. Maintenant que nous en savons plus sur votre situation, quelle est la raison de votre retrait ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 94,
    "pere": "ask-infraction-5",
    "cle": "mr-alcoolemie",
    "message": {
      "img": "alcoolemie.png",
      "texte": "Alcoolémie"
    },
    "type": "choice",
    "ordre": 1
  },
  {
    "id": 95,
    "pere": "ask-infraction-5",
    "cle": "mr-stupefiant",
    "message": {
      "img": "stupefiants.png",
      "texte": "Stupéfiants"
    },
    "type": "choice",
    "ordre": 2
  },
  {
    "id": 96,
    "pere": "ask-infraction-5",
    "cle": "mr-double",
    "message": {
      "img": "alcoolemie-stupefiant.png",
      "texte": "Alcoolémie et stupéfiants"
    },
    "type": "choice",
    "ordre": 3
  },
  {
    "id": 97,
    "pere": "ask-infraction-5",
    "cle": "mr-autres",
    "message": {
      "img": "vitesse.png",
      "texte": "Perte de point, excès de vitesse ou autre."
    },
    "type": "choice",
    "ordre": 4
  },
  {
    "id": 98,
    "pere": "i-lettre-quit",
    "cle": "time-to-quit",
    "message": "Vous serez redirigé…",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 99,
    "pere": "a-lettre-quit",
    "cle": "time-to-quit",
    "message": "Vous serez redirigé…",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 100,
    "pere": "professionnel",
    "cle": "pro-ask-status",
    "message": "Très bien. Qui êtes-vous ?",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 101,
    "pere": "pro-ask-status",
    "cle": "pro-status-choices",
    "message": {
      "img": "",
      "texte": "Un profil RH, Formation, Qualité ou Administratif"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 102,
    "pere": "pro-ask-status",
    "cle": "pro-status-employee",
    "message": {
      "img": "",
      "texte": "Un salarié"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 103,
    "pere": "pro-ask-status",
    "cle": "pro-status-boss",
    "message": {
      "img": "",
      "texte": "Mon propre patron"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 104,
    "pere": "pro-status-choices",
    "cle": "pro-c-ask-objectif",
    "message": "<p>Très bien, vous souhaitez faire passer un test psychotechnique à un ou plusieurs de vos collaborateurs.</p><p>Quel est votre objectif ?</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 105,
    "pere": "pro-status-employee",
    "cle": "pro-e-ask-objectif",
    "message": "<p>En règle générale, l'employeur (actuel ou futur) prend en charge le coût du test psychotechnique.</p><p>Il peut toutefois vous demander de l'effectuer à vos frais avant une prise de poste.</p><p>Souhaitez-vous :</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 106,
    "pere": "pro-status-boss",
    "cle": "pro-b-ask-objectif",
    "message": "<p>Indiquez votre ville ou votre département pour voir les prochaines sessions de test près de chez vous.</p>",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 107,
    "pere": "pro-c-ask-objectif",
    "cle": "pro-recruter",
    "message": {
      "img": "recrutement.png",
      "texte": "Recruter un candidat"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 108,
    "pere": "pro-c-ask-objectif",
    "cle": "pro-coherence-reglementaire",
    "message": {
      "img": "obligation-loi.png",
      "texte": "Mettre mes équipes en conformité réglementaire"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 109,
    "pere": "pro-c-ask-objectif",
    "cle": "pro-evaluation",
    "message": {
      "img": "visite-medicale.png",
      "texte": "Évaluer un ou plusieurs salariés suite à une visite médicale"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 110,
    "pere": "pro-e-ask-objectif",
    "cle": "pro-verification",
    "message": {
      "img": "",
      "texte": "Vérifier la prise en charge avec mon employeur"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 111,
    "pere": "pro-e-ask-objectif",
    "cle": "pro-recherche-test",
    "message": {
      "img": "",
      "texte": "Chercher un test psychotechnique"
    },
    "type": "choice",
    "ordre": 0
  },
  {
    "id": 113,
    "pere": "pro-recruter",
    "cle": "pro-ask-informations",
    "message": "Parfait. Complétez le formulaire ci-dessous pour que notre responsable des tests psychotechniques professionnels vous contacte rapidement.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 114,
    "pere": "pro-coherence-reglementaire",
    "cle": "pro-ask-informations",
    "message": "Parfait. Complétez le formulaire ci-dessous pour que notre responsable des tests psychotechniques professionnels vous contacte rapidement.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 115,
    "pere": "pro-evaluation",
    "cle": "pro-ask-informations",
    "message": "Parfait. Complétez le formulaire ci-dessous pour que notre responsable des tests psychotechniques professionnels vous contacte rapidement.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 116,
    "pere": "pro-ask-informations",
    "cle": "form-pro",
    "message": [
      {
        "key": "formNomPro",
        "type": "text",
        "label": "Votre nom",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Votre nom est requis."
          }
        ]
      },
      {
        "key": "formEmailPro",
        "type": "email",
        "label": "Votre email",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Votre email est requis."
          },
          {
            "name": "email",
            "validator": "email",
            "message": "Veuillez renseigner un email valide."
          }
        ]
      },
      {
        "key": "formPhonePro",
        "type": "text",
        "label": "Votre téléphone",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Votre téléphone est requis."
          }
        ]
      },
      {
        "key": "formSocietePro",
        "type": "text",
        "label": "Votre société",
        "size": "100",
        "validations": []
      },
      {
        "key": "formMessagePro",
        "type": "textarea",
        "label": "Votre message",
        "size": "100",
        "validations": [
          {
            "name": "required",
            "validator": "required",
            "message": "Votre message est requis."
          }
        ]
      }
    ],
    "type": "form",
    "ordre": 0
  },
  {
    "id": 119,
    "pere": "form-pro",
    "cle": "pro-form-done",
    "message": "Merci, voici du contenu qui pourrait vous intéresser.",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 121,
    "pere": "pro-recherche-test",
    "cle": "pro-form-search-test",
    "message": "Rechercher un test psychotechnique",
    "type": "msg",
    "ordre": 0
  },
  {
    "id": 120,
    "pere": "pro-verification",
    "cle": "pro-come-back",
    "message": "D'accord. Revenez sur aaaep.fr dès que la prise en charge est confirmée avec votre employeur. En attendant, voici quelques contenus utiles.",
    "type": "msg",
    "ordre": 0
  }
];
